module.exports = {
  Character: {
    PluginName: "Character",
  },
};
